import { FC, useContext, useMemo, memo } from "react";
import { TaskAddEditContext } from "../../../../contexts/TaslAddEditFormContext";
import { CurrentTab, TabNavigator } from "../../../UiLib/TabNavigator/TabNavigator";
import MainFormTab from "../FormTabs/MainFormTab";
import ExitCross from "../../../../assets/cancelGreey.svg";
import DeadlineFormTab from "../FormTabs/DeadlineFormTab";
import SubscribersFormTab from "../FormTabs/SubscribersFormTab";
import ProgressFormTab from "../FormTabs/ProgressFormTab";
import TaskFormOldMark from "./TaskFormOldMark";
import TaskFormHeader from "./TaskFormHeader";

const MemoizedMainFormTab = memo(MainFormTab);
const MemoizedDeadlineFormTab = memo(DeadlineFormTab);
const MemoizedSubscribersFormTab = memo(SubscribersFormTab);
const MemoizedProgressFormTab = memo(ProgressFormTab);
const MemoizedTaskFormOldMark = memo(TaskFormOldMark);

const TaskFormMain: FC = () => {
    const taskAddEditFormContext = useContext(TaskAddEditContext);

    const widgetMode: string = useMemo(() => 
        taskAddEditFormContext.mode === "edit" ? "Редактирование задачи" : "Создание задачи",
        [taskAddEditFormContext.mode]
    );

    const handleClose = useMemo(() => 
        () => taskAddEditFormContext.closeAndClearTree(),
        [taskAddEditFormContext.closeAndClearTree]
    );

    const handleTaskAction = useMemo(() => 
        taskAddEditFormContext.handleTaskAction,
        [taskAddEditFormContext.handleTaskAction]
    );

    const tabCallbacks = useMemo(() => [
        () => taskAddEditFormContext.changePage(0),
        () => taskAddEditFormContext.changePage(1),
        () => taskAddEditFormContext.changePage(2),
        () => taskAddEditFormContext.changePage(3),
    ], [taskAddEditFormContext.changePage]);

    return (
        <div className="task__create--edit__form">
            {/* Окно подтверждения */}
            {taskAddEditFormContext.openConfirmWindow && taskAddEditFormContext.blockDomCustomAllert()}

            {/* Старый марк */}
            {taskAddEditFormContext.openOldMark && taskAddEditFormContext.mode === "edit" && (
                <MemoizedTaskFormOldMark />
            )}

            {/* Хедер виджета */}
            <TaskFormHeader 
                onClose={handleClose}
                widgetMode={widgetMode}
            />

            {/* Навигация */}
            <div className="task__create--edit__form--tab--block">
                <TabNavigator
                    keepMounted={true}
                >
                    <CurrentTab
                        key="basic"
                        name="Основное"
                        callBack={tabCallbacks[0]}
                    >
                        <MemoizedMainFormTab />
                    </CurrentTab>
                    <CurrentTab
                        key="deadline"
                        name="Сроки задачи"
                        callBack={tabCallbacks[1]}
                    >
                        <MemoizedDeadlineFormTab />
                    </CurrentTab>
                    <CurrentTab
                        key="subscribers"
                        name="Подписчики"
                        callBack={tabCallbacks[2]}
                    >
                        <MemoizedSubscribersFormTab />
                    </CurrentTab>
                    <CurrentTab
                        key="progress"
                        name="Прогресс"
                        callBack={tabCallbacks[3]}
                    >
                        <MemoizedProgressFormTab />
                    </CurrentTab>
                </TabNavigator>
            </div>

            {/* Кнопки действий */}
            <div className="task__create--edit__form--tab__panel--button">
                <div
                    className="task__create--edit__form--tab__panel--button__add"
                    id="TaskAddEditForm_submit_btn"
                    onClick={handleTaskAction}
                >
                    <button
                        data-testid={
                            taskAddEditFormContext.taskData !== undefined 
                                ? "button-add_task_form-save" 
                                : "button-add_task_form-create"
                        }
                    >
                        {taskAddEditFormContext.taskData !== undefined ? "Сохранить" : "Создать"}
                    </button>
                </div>
                <div
                    className="task__create--edit__form--tab__panel--button__close"
                    id="TaskAddEditForm_cancel_btn"
                    onClick={handleClose}
                >
                    <button data-testid="button-add_task_form-cancel">Отмена</button>
                </div>
            </div>
        </div>
    );
};

export default memo(TaskFormMain);